import { IRefundCalculatorResponseDto } from '../../../refund-calculator-types';

import CalculatorCategoryTitle from '../calculator-category-title/calculator-category-title';
import CalculatorItemsCategory from '../calculator-items-category/calculator-items-category';
import CalculatorFeesCategory from '../calculator-fees-category/calculator-fees-category';
import CalculatorOtherCostCategory from '../calculator-other-cost-category/calculator-other-cost-category';
import CalculatorLineItem from '../calculator-line-item/calculator-line-item';

import './calculator-breakdown.scss';

interface ICalculatorBreakdownProps {
    data: IRefundCalculatorResponseDto;
}

const CalculatorBreakdown: React.FC<ICalculatorBreakdownProps> = ({ data }) => {
    return (
        <div className="refund-calculator__breakdown">
            <div className="refund-calculator__breakdown-header">
                <CalculatorLineItem
                    description="Objects"
                    price="Price"
                    tax="Tax & Tax Rate"
                />
            </div>
            <div className="refund-calculator__breakdown-content">
                {(data.original_items.total_amount && data.original_items.total_amount.amount > 0) ? (
                    <CalculatorItemsCategory
                        data={data.original_items.items}
                        title={
                            <CalculatorCategoryTitle
                                title="Original Items | Total"
                                amount={data.original_items.total_amount.amount}
                                tax={data.original_items.total_amount.tax}
                            />
                        }
                    />
                ) : null}
                {(data.new_items.total_amount && data.new_items.total_amount.amount > 0) ? (
                    <CalculatorItemsCategory
                        data={data.new_items.items}
                        title={
                            <CalculatorCategoryTitle
                                title="New Items | Total"
                                amount={data.new_items.total_amount.amount}
                                tax={data.new_items.total_amount.tax}
                            />
                        }
                    />
                ) : null}
                {(data.fees.total_amount && data.fees.total_amount.amount > 0) ? (
                    <CalculatorFeesCategory
                        data={data.fees.items}
                        title={
                            <CalculatorCategoryTitle
                                title="Fees | Total"
                                amount={data.fees.total_amount.amount}
                                tax={data.fees.total_amount.tax}
                            />
                        }
                    />
                ) : null}
                {(data.other_costs.total_amount && data.other_costs.total_amount.amount > 0) ? (
                    <CalculatorOtherCostCategory
                        data={data.other_costs}
                        title={
                            <CalculatorCategoryTitle
                                title="Other Costs | Total"
                                amount={data.other_costs.total_amount.amount}
                                tax={data.other_costs.total_amount.tax}
                            />
                        }
                    />
                ) : null}
            </div>
        </div>
    );
};

export default CalculatorBreakdown;
